"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deliveryChannelsQuery = void 0;
var _fetching = require("@ori/fetching");
const pickupPointFragment = (0, _fetching.gql)`
  fragment PickupPoint on PickupPoint {
    deliveryChannelId
    isAllowed
    shippingFee
    originalShippingFee
    isShippingJoker
    outOfStockQuantity
    estimatedDeliveryDate
    deliveryChannel {
      coordinates {
        latitude
        longitude
      }
      description
      deliveryMethod
      workingHours
      telephoneNumber
      address {
        addressId
        city
        streetAddress
        zipcode
      }
    }
  }
`;
const deliveryChannelsQuery = exports.deliveryChannelsQuery = (0, _fetching.gql)`
  query deliveryChannels(
    $sessionId: String!
    $latitude: Float
    $longitude: Float
    $radius: Float
    $searchTerm: String
    $skip: Int!
    $top: Int!
  ) {
    shopping {
      shoppingSession(sessionId: $sessionId) {
        deliveryChannels(
          latitude: $latitude
          longitude: $longitude
          radius: $radius
          searchTerm: $searchTerm
          skip: $skip
          top: $top
        ) {
          collection {
            ...PickupPoint
          }
          totalRecords
        }
      }
    }
  }
  ${pickupPointFragment}
`;